<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">{{ value.TransferType == 0 ? 'Giriş Tarihi' : 'Başlangıç Tarihi' }}</label>
            <v-date-picker v-model="value.StartDate" :placeholder="value.TransferType == 0 ? 'Giriş Tarihi' : 'Başlangıç Tarihi'"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">{{ value.TransferType == 0 ? 'Çıkış Tarihi' : 'Bitiş Tarihi' }}</label>
            <v-date-picker v-model="value.EndDate" :placeholder="value.TransferType == 0 ? 'Çıkış Tarihi' : 'Bitiş Tarihi'"></v-date-picker>
        </div>
        <div class="col-12" v-if="value.TransferType == 1">
            <label class="form-label">Unvan</label>
            <v-select-list :disabled="value.BranchId == null" :options="titles" label="Name" v-model="title" placeholder="Unvan"></v-select-list>
        </div>
        <div class="col-12" v-if="value.TransferType == 2">
            <label class="form-label">Görev Yeri</label>
            <v-select-list :disabled="value.BranchId == null" :options="garages" label="GarageName" v-model="garage" placeholder="Görev Yeri"></v-select-list>
        </div>
    </div>
</template>

<script>
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import VehicleOperationsApi from '@/api/vehicle-operations'

export default{
    props:{
        value:Object
    },
    data(){
        return {
            titles:[],
            garages:[]
        }
    },
    mounted(){
        this.getTitles()
        this.getGarages()
    },
    methods:{
        getTitles(){
            if(this.value.BranchId && this.value.TransferType == 1){
                HumanResourcesParameterApi.EmployeeDepartmentTitle.List(this.value.BranchId).then(res=>{
                    this.titles = res.data.Data
                })
            }
        },
        getGarages(){
            if(this.value.BranchId && this.value.TransferType == 2){
                VehicleOperationsApi.Garage.ListByBranch(this.value.BranchId).then(res=>{
                    this.garages = res.data.Data
                })
            }
        }
    },
    computed:{
        title:{
            get:function(){ 
                return this.titles.find(t=> t.Id == this.value.TitleId) || null
            },
            set:function(value){
                this.value.TitleId = value?.Id || null
            }
        },
        garage:{
            get:function(){ 
                return this.garages.find(t=> t.Id == this.value.GarageId) || null
            },
            set:function(value){
                this.value.GarageId = value?.Id || null
            }
        },
    }
}
</script>